import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

const DEFAULT_STEPS = [
    "Basic Info",
    "Header",
    "Body",
    "Footer (Optional)",
    "Buttons (Optional)",
];

export const AUTH_TEMPLATE_STEPS = [
    "Basic Info",
    "OTP Message",
    "Code Expiration",
    "OTP Button",
];

export default function TemplateCreationSteppers({ currentStep, steps = DEFAULT_STEPS, accent = "#111827" }) {
    return (
        <Box
            sx={{
                width: "100%",
                px: { xs: 0.5, sm: 1 },
                py: 1.5,
                borderRadius: 2,
                border: "1px solid rgba(0,0,0,0.08)",
                backgroundColor: "rgba(255,255,255,0.9)",
            }}
        >
            <Stepper
                activeStep={currentStep}
                alternativeLabel
                sx={{
                    "& .MuiStepConnector-line": {
                        borderColor: "rgba(0,0,0,0.12)",
                    },
                    "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line, & .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
                        borderColor: accent,
                    },
                    "& .MuiStepIcon-root": {
                        color: "rgba(0,0,0,0.18)",
                    },
                    "& .MuiStepIcon-root.Mui-active, & .MuiStepIcon-root.Mui-completed": {
                        color: accent,
                    },
                    "& .MuiStepLabel-label": {
                        fontWeight: 600,
                        fontSize: "0.78rem",
                        color: "text.secondary",
                    },
                    "& .MuiStepLabel-label.Mui-active, & .MuiStepLabel-label.Mui-completed": {
                        color: "text.primary",
                        fontWeight: 700,
                    },
                }}
            >
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
}
